import React from "react";
import { useLang } from "../context/LanguageContext";
import { useSeo } from "../hooks/useSeo";
import { COMPANY, DESCRIPTION_NO, Section, ContactBlock } from "./Personvern";

export default function Vilkar() {
  const { t, lang } = useLang();
  useSeo({ title: t.seo.vilkar.title, description: t.seo.vilkar.description, path: "/vilkar", lang });

  return (
    <main data-testid="vilkar-page" className="bg-ink text-cream pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <span className="text-xs font-bold tracking-widest uppercase text-amber">Juridisk</span>
        <h1 className="mt-4 font-display text-4xl md:text-6xl font-extrabold leading-[1.05] tracking-tighter" style={{ letterSpacing: "-0.04em" }}>
          Vilkår for bruk
        </h1>
        <p className="mt-4 text-cream/50 text-sm">Sist oppdatert: {COMPANY.updated}</p>

        <Section title="1. Om tjenesten">
          <p>{DESCRIPTION_NO}</p>
          <p>Ved å bruke nettsiden eller tjenesten godtar du disse vilkårene.</p>
        </Section>

        <Section title="2. Bruk av tjenesten">
          <p>Du forplikter deg til å bruke Pendli på en lovlig måte og ikke misbruke tjenesten.</p>
        </Section>

        <Section title="3. Immaterielle rettigheter">
          <p>
            Alt innhold på nettsiden, inkludert logo, design, tekst og programvare, tilhører {COMPANY.name} eller våre lisensgivere.
          </p>
        </Section>

        <Section title="4. Ansvarsbegrensning">
          <p>
            Pendli leveres «som den er». Vi forsøker å holde tjenesten tilgjengelig og korrekt, men kan ikke garantere feilfri drift til enhver tid.
          </p>
        </Section>

        <Section title="5. Endringer">
          <p>
            Vi kan oppdatere disse vilkårene fra tid til annen. Vesentlige endringer vil publiseres på nettsiden.
          </p>
        </Section>

        <Section title="6. Lovvalg">
          <p>
            Disse vilkårene er underlagt norsk lov. Eventuelle tvister behandles av norske domstoler.
          </p>
        </Section>

        <ContactBlock />
      </div>
    </main>
  );
}
